import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Phone, RotateCcw, ShieldCheck, Truck, Zap } from 'lucide-react';
import { SITE } from '../config/site';

const LINKS = {
  shop: [['Shop all products', '/products'], ['Car batteries', '/products?category=Batteries'], ['Request a quote', '/quotes'], ['Track an order', '/orders'], ['Wishlist', '/wishlist'], ['Compare products', '/compare']],
  help: [['Blog', '/blog'], ['Contact us', '/contact'], ['Shipping information', '/shipping-information'], ['Returns & exchanges', '/returns-exchanges'], ['FAQ', '/faq'], ['Terms & conditions', '/terms-and-conditions'], ['Privacy policy', '/privacy-policy']],
};
const BADGES = [[Truck, 'Fast dispatch', 'Sydney and Melbourne'], [ShieldCheck, 'Australian warranty', 'Official manufacturer cover'], [RotateCcw, 'Easy returns', 'See our returns policy'], [Zap, 'Secure payments', 'Protected checkout']];

const Footer = () => (
  <footer className="bg-gray-900 text-gray-300">
    <div className="container mx-auto px-4 py-10 sm:py-12">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
        <div className="col-span-2 lg:col-span-1">
          <h3 className="text-white font-bold text-lg mb-4">About us</h3>
          <p className="text-sm">{SITE.tagline}. We supply car batteries, filters, brakes, lighting and electrical parts from trusted brands, dispatched from our Sydney and Melbourne warehouses.</p>
        </div>
        <nav aria-label="Shop links">
          <h3 className="text-white font-bold text-lg mb-4">Shop</h3>
          <ul className="space-y-2 text-sm">{LINKS.shop.map(([l, to]) => <li key={l}><Link to={to} className="hover:text-red-500 transition">{l}</Link></li>)}</ul>
        </nav>
        <nav aria-label="Customer service links">
          <h3 className="text-white font-bold text-lg mb-4">Customer service</h3>
          <ul className="space-y-2 text-sm">{LINKS.help.map(([l, to]) => <li key={l}><Link to={to} className="hover:text-red-500 transition">{l}</Link></li>)}</ul>
        </nav>
        <div className="col-span-2 lg:col-span-1">
          <h3 className="text-white font-bold text-lg mb-4">Contact</h3>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2"><MapPin size={18} className="mt-0.5 shrink-0" /><span>{SITE.warehouses.map((w) => `${w.name} (${w.place})`).join(' · ')}</span></li>
            <li className="flex items-center gap-2"><Phone size={18} className="shrink-0" /><a href={`tel:${SITE.phone.replace(/\s/g, '')}`} className="hover:text-red-500">{SITE.phone}</a></li>
            <li className="flex items-center gap-2"><Mail size={18} className="shrink-0" /><a href={`mailto:${SITE.email}`} className="hover:text-red-500 break-all">{SITE.email}</a></li>
          </ul>
          <p className="mt-4 text-sm font-semibold text-white">Business hours</p>
          <ul className="text-sm">{SITE.hours.map((h) => <li key={h}>{h}</li>)}</ul>
        </div>
      </div>
    </div>
    <div className="bg-gray-800">
      <div className="container mx-auto px-4 py-6 grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
        {BADGES.map(([Icon, t, d]) => (
          <div key={t} className="flex flex-col items-center"><Icon size={26} className="text-red-500 mb-1.5" strokeWidth={1.5} /><div className="text-white font-semibold text-sm">{t}</div><div className="text-xs">{d}</div></div>
        ))}
      </div>
    </div>
    <div className="bg-black/60">
      <div className="container mx-auto px-4 py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs sm:text-sm text-center">
        <span>© {new Date().getFullYear()} {SITE.legalName}. {SITE.abn}. All rights reserved.</span>
        <span className="text-gray-400">{SITE.gstNote}</span>
      </div>
    </div>
  </footer>
);
export default Footer;
